export enum SpecialCharacter {
  thinSpace = '\u2009',
  noBreakSpace = '\u00a0',
  zeroWidthSpace = '\u200B',
  zeroWidthNoBreakSpace = '\uFEFF',
  nonBreakingHyphen = '\u2011',
  softHyphen = '\u00AD',
  enDash = '\u2013',
  emDash = '\u2014',
  emSpace = '\u2003',
  enSpace = '\u2002',

  // These are not urlencoded but special characters you can use to include line breaks in emails.
  emailLineBreak = '%0D%0A',
  emailDoubleLineBreak = '%0D%0A%0D%0A',
}
